// extracted by mini-css-extract-plugin
export default {"selectBox":"DropDownCmp_selectBox__-97JP","requiredAsterisk":"DropDownCmp_requiredAsterisk__Fvw3J"};